import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";
import './App.css';
import NavBar from './components/navbar'
import HomePage from "./components/homePage";
import ProfilePage from "./components/profilePage";
import LoginForm from "./components/loginForm";
import Logout from "./components/logout";
import SaveToken from "./components/saveToken";
import RegisterForm from "./components/registerForm";
import auth from "./services/authService";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './components/checkoutForm';
import PlanList from './components/planList';
import ForgotPasswordForm from './components/forgotPasswordForm';
import ResetPasswordForm from './components/resetPasswordForm';
import IntelPage from './components/intelPage';
import { ToastContainer } from 'react-toastify';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class App extends Component {
  state = {
    user: null,
    isMobile: window.innerWidth >= 992,
    sidebarOpen: window.innerWidth >= 992
  };

  handleSidebarOpen = (open) => {
    this.setState({ sidebarOpen: open })
  }

  async componentDidMount() {
    const user = await auth.getCurrentUser();
    this.setState({ user });
  }

  render() {
    const { user, sidebarOpen } = this.state;

    return (
      <Elements stripe={stripePromise}>
        <main className="container">
          <NavBar 
            user={user}
            onSidebarOpen={this.handleSidebarOpen}/>
          <ToastContainer />
          <div className="nav-bar-padding"></div>
          <Switch>
            <Route path="/register" component={RegisterForm} />
            <Route path="/forgot" component={ForgotPasswordForm} />
            <Route path="/reset" component={ResetPasswordForm} />
            <Route 
              path="/login" 
              render={(props) => <LoginForm {...props} user={user} /> } />
            <Route path="/logout" component={Logout} />
            <Route 
              path="/plans" 
              render={(props) => <PlanList {...props} user={user} /> } />
            <Route 
              path="/checkout"
              render={(props) => <CheckoutForm {...props} user={user} /> } />
            <Route 
              path="/profile" 
              render={(props) => <ProfilePage {...props} user={user} /> } />
            <Route 
              path="/savetoken" 
              render={(props) => <SaveToken {...props} user={user} /> } />
            <Route 
              path="/intel" 
              render={(props) => <IntelPage {...props} user={user} /> } />
            <Route 
              path="/" 
              exact 
              render={ props => <HomePage 
                                  {...props} 
                                  user={user}
                                  sidebarOpen={sidebarOpen}
                                  onSidebarOpen={this.handleSidebarOpen} /> } />
          </Switch>
        </main>
      </Elements>
    );
  }
}

export default App;
